import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { ConfigurationFilter, configurationFilterFactory, ProductConfiguration } from '../../../models/fitting-query-params.model';
import * as fromFittings from '../../../store/fromFittings.barrel';
import { AppLookup } from 'src/app/models/lookup.model';

@Component({
  selector: 'app-associated-product-configurations-modal',
  templateUrl: './associated-product-configurations-modal.component.html',
  styleUrls: ['./associated-product-configurations-modal.component.scss']
})
export class AssociatedProductConfigurationsModalComponent implements OnInit {
  @Input() partNumber?: string;
  @Input() configurations: ProductConfiguration[] = [];

  configurationsWithFilter$: Observable<ProductConfiguration[]> = of([]);
  configurationsWithoutFilter$: Observable<ProductConfiguration[]> = of([]);
  configurationFilter$: Observable<ConfigurationFilter | undefined> = of();
  hasFilterApplied$: Observable<boolean> = of(false);
  tappedHoleOptions$: Observable<AppLookup[]> = of([]);
  oringOptions$: Observable<AppLookup[]> = of([]);
  bevelOptions$: Observable<AppLookup[]> = of([]);

  constructor(public modal: NgbActiveModal, private fb: FormBuilder, private store: Store<fromFittings.State>) { }

  ngOnInit(): void {
    this.configurationFilter$ = this.store.select(fromFittings.selectAssociatedPartsConfigurationQuery);
    this.configurationsWithFilter$ = this.store.select(fromFittings.selectAssociatedPartsActiveFittingConfigurationsWithFilter);
    this.configurationsWithoutFilter$ = this.store.select(fromFittings.selectedActiveFittingSelectedAssociatedPartConfigurations);
    this.hasFilterApplied$ = this.store.select(fromFittings.selectAssociatedPartsActiveFittingConfigurationsHasFilter);

    this.tappedHoleOptions$ = this.store.select(fromFittings.selectConfigurationFilterLookupsTappedHoles);
    this.oringOptions$ = this.store.select(fromFittings.selectConfigurationFilterLookupsOrings);
    this.bevelOptions$ = this.store.select(fromFittings.selectConfigurationFilterLookupsBevels);
  }

  configurationAssociatePartFilterChange(configFilter: Partial<ConfigurationFilter>) {
    this.store.dispatch(fromFittings.changeAssociateProductConfigurationFilter({ obj: configFilter }))
  }

  configurationAssociatePartFilterChangeTappedBlindOption(option: { value: string, status: boolean }) {
    this.store.dispatch(fromFittings.tappedBlindChangeAssPartLevel({ obj: option }));
  }

  configurationAssociatePartFilterChangeOringOption(option: { value: string, status: boolean }) {
    this.store.dispatch(fromFittings.oringChangeAssPartLevel({ obj: option }));
  }

  configurationAssociatePartFilterChangeBevelOption(option: { value: string, status: boolean }) {
    this.store.dispatch(fromFittings.bevelChangeAssPartLevel({ obj: option }));
  }

  clearActiveFilter(): void {
    this.store.dispatch(fromFittings.changeActiveAssociatedPart({ partNumber: 'foobar' }))
    this.modal.close();
  }
}
